import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Warehouse',
    column_type: 'id',
    label_key_path: 'warehouse.id',
  },
  created_at: {
    model_name: 'Warehouse',
    column_type: 'datetime',
    label_key_path: 'warehouse.createdAt',
  },
  updated_at: {
    model_name: 'Warehouse',
    column_type: 'datetime',
    label_key_path: 'warehouse.updatedAt',
  },
  name: {
    model_name: 'Warehouse',
    column_type: 'string',
    label_key_path: 'warehouse.name',
  },
  jushuitan_id: {
    model_name: 'Warehouse',
    column_type: 'integer',
    label_key_path: 'warehouse.jushuitanId',
  },
  virtual: {
    model_name: 'Warehouse',
    column_type: 'boolean',
    label_key_path: 'warehouse.virtual',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
